import { LegacyDevice } from 'console/device/device';
import { getDeviceSpecV2 } from 'z3k-parser/model/device-spec/z3k-feature-flags';
import { HeatingTab } from './tab';
import { DevicePermission } from 'console/device/device_ts';
import { isSX } from 'console/shared/contexts/device/config/utils';
import { DefaultTabKey } from 'console/shared/content/tab/types';
export const heating_tab_definition = {
    key: DefaultTabKey.heat_tab,
    title: (device_type) => {
        if (device_type && isSX(device_type)) {
            return 'Управление';
        }
        return 'Отопление';
    },
    iconclass: (device_type) => {
        if (device_type && isSX(device_type)) {
            return 'ui-icon-tab-state';
        }
        return 'ui-icon-tab-temperature';
    },
    should_appear: (device, legacy_account, r_device, r_account, service_view) => {
        if (!LegacyDevice.has_access(r_account.id, r_device, DevicePermission.view_state)) {
            return false;
        }
        if (LegacyDevice.is_legacy_firmware(r_device.capabilities, r_device.thermostat_enabled, r_device.firmware_version, r_device.device_type)) {
            return false;
        }
        if (r_device.device_type?.code == null) {
            return false;
        }
        if (isSX(r_device.device_type)) {
            return true;
        }
        const device_spec = getDeviceSpecV2(r_device.device_type?.code, r_device.hardware_type?.code ?? '');
        if ((!device_spec || !device_spec.heating.has_heating) &&
            !LegacyDevice.is_legacy_heating(r_device.capabilities, r_device.thermostat_enabled, r_device.device_type, r_device.firmware_version)) {
            return false;
        }
        //Всегда показываем вкладку отопления в сервисном режиме
        return service_view ? true : r_device?.show_heating_tab ?? true;
    },
    render: HeatingTab,
    should_appear_depends_on: [
        'id',
        'capabilities',
        'device_type',
        'show_heating_tab',
        'hardware_type',
        'online',
        'z3k_config',
        'tempstep',
        'ui_settings',
        'access',
        'user_id',
        'timezone',
        'thermostat_enabled',
    ],
    data_tooltip: 'heat-tab-icon',
};
